var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as classNames from 'classnames';
import util from './util';
var styles = util.styles;
/**
 * @hidden
 */
var ButtonGroup = (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._element = null;
        return _this;
    }
    ButtonGroup.prototype.mapButtons = function (children) {
        var _this = this;
        var count = React.Children.count(children);
        return React.Children.map(children, function (child, index) {
            if (React.isValidElement(child)) {
                return _this.renderButton(child, index, (index === count - 1));
            }
            return child;
        });
    };
    ButtonGroup.prototype.renderButton = function (child, index, isLast) {
        var rtl = this.props.dir !== undefined
            ? this.props.dir === 'rtl'
            : (this._element && (getComputedStyle(this._element).direction === 'rtl') || false);
        var buttonClasses = classNames((_a = {},
            _a[styles['group-start']] = rtl ? isLast : index === 0,
            _a[styles['group-end']] = rtl ? index === 0 : isLast,
            _a));
        var buttonProps = __assign({}, child.props, { className: buttonClasses, style: { 'width': "" + this.props.width }, disabled: this.props.disabled || undefined });
        return React.cloneElement(child, buttonProps, child.props.children);
        var _a;
    };
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var buttons = this.mapButtons(this.props.children);
        var groupClasses = classNames([styles['button-group']], (_a = {},
            _a[styles['state-disabled']] = this.props.disabled,
            _a[styles['button-group-stretched']] = !!this.props.width,
            _a), this.props.className);
        var groupProps = {
            className: groupClasses,
            style: { 'width': "" + this.props.width },
            dir: this.props.dir,
            // Accessibility properties
            role: 'group',
            'aria-disabled': this.props.disabled || undefined,
            'aria-multiselectable': true
        };
        return (React.createElement("div", __assign({ ref: function (div) { _this._element = div; } }, groupProps, { className: groupClasses }), buttons));
        var _a;
    };
    return ButtonGroup;
}(React.Component));
export default ButtonGroup;
ButtonGroup.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    width: PropTypes.string,
    dir: PropTypes.string
};
ButtonGroup.defaultProps = {
    disabled: false
};
//# sourceMappingURL=ButtonGroup.js.map